import './bootstrap';
import * as Popper from "@popperjs/core"
import * as bootstrap from 'bootstrap'
import '../js/utils/custom-dialog-prototype';
import './utils/format-phone';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css';
import 'datatables.net-responsive-bs5';

// Set global DataTables defaults to silence error alerts
// This must be done after jQuery and DataTables are loaded
$(document).ready(function() {
  if (typeof $.fn.dataTable !== 'undefined' && $.fn.dataTable.ext) {
    $.fn.dataTable.ext.errMode = 'none'; // Silences DataTables error alerts globally
  }
});

import 'daterangepicker/daterangepicker.css';
import 'daterangepicker';
import 'jquery-mask-plugin';

import '@fortawesome/fontawesome-free/css/all.min.css';

window.bootstrap = bootstrap;
window.Popper = Popper;

let flag = false;
$('.burger-menu').on('click', function() {
  flag = !flag;
  flag ? $('.side-nav-header').addClass('open') : $('.side-nav-header').removeClass('open');
});

const adjustFooterPadding = () => {
  const footerHeight = $('footer').height();
  $('body').css('padding-bottom', footerHeight + 'px');
};

// Initial adjustment
adjustFooterPadding();

// Reapply adjustment on window resize
window.addEventListener('resize', () => {
  adjustFooterPadding();
});

/** Retain current active tab after pageload **/
$('#myTab button').click(function(e) {
  e.preventDefault();
  $(this).tab('show');
});

// store the currently selected tab in the hash value
$("ul.nav > li > button").on("shown.bs.tab", function(e) {
  var id = $(e.target).attr("id");
  window.location.hash = id;
});

// on load of the page: switch to the currently selected tab
var hash = window.location.hash;
$('#myTab button[id="' + hash.substr(1) + '"]').tab('show');
